import PropTypes from 'prop-types';
import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';
import RoleBasedGuard from 'src/auth/guard/role-based-guard';

import { RouteGuard } from 'src/components/permissions';
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const InsuranceProviders = lazy(
  () => import('src/sections/insurance/insurance-providers/view/insurance-providers-list-view')
);
const AuthorizationsListView = lazy(
  () => import('src/sections/insurance/insurance-providers/authorizations-list-screen')
);
const InsuranceAuditPage = lazy(() => import('src/pages/medicore/insurance/insurance-audit'));

// ----------------------------------------------------------------------

/**
 * Componente wrapper para proteger rutas de seguros con permisos específicos
 * ⚠️ ULTRA-RESTRICTIVO: Solo master ve todo, otros usuarios solo lo que tienen permisos
 */
const ProtectedRoute = ({ route, children }) => (
  <RouteGuard route={route} fallbackRoute="/medicore" showFallback>
    <Suspense fallback={<LoadingScreen />}>{children}</Suspense>
  </RouteGuard>
);

ProtectedRoute.propTypes = {
  route: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

// ----------------------------------------------------------------------

export const medicoreInsuranceRoutes = [
  {
    path: 'medicore/insurance',
    element: (
      <AuthGuard>
        <RoleBasedGuard roles={['doctor', 'employee']}>
          <DashboardLayout>
            <Outlet />
          </DashboardLayout>
        </RoleBasedGuard>
      </AuthGuard>
    ),
    children: [
      {
        path: 'providers',
        children: [
          {
            path: 'list',
            element: (
              <ProtectedRoute route="/medicore/insurance/providers/list">
                <InsuranceProviders />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: 'authorizations',
        children: [
          {
            path: 'list',
            element: (
              <ProtectedRoute route="/medicore/insurance/authorizations/list">
                <AuthorizationsListView />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: 'audit',
        children: [
          {
            path: 'list',
            element: (
              <ProtectedRoute route="/medicore/insurance/audit/list">
                <InsuranceAuditPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
    ],
  },
];
